import React, { useState, useEffect } from 'react';
import { useObservable } from 'react-use-observable';

import { Checkbox } from 'antd';

import { useFormikContext } from 'formik';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

interface IProps {
  handleUncheckAll: () => void;
  selectedQuantity: number;
}

export const Header = ({ handleUncheckAll, selectedQuantity }: IProps) => {
  const [affiliates] = useObservable(() => selectAffiliateService.getAffiliates(), []);
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    const isChecked = affiliates?.length && affiliates?.length === selectedQuantity;
    setChecked(isChecked);

    const isIndeterminate = affiliates?.length > selectedQuantity && !!selectedQuantity;
    setIndeterminate(isIndeterminate);
  }, [affiliates, selectedQuantity]);

  const handleCheckAll = () => setFieldValue('affiliates', affiliates);

  const onClick = affiliates?.length === selectedQuantity ? handleUncheckAll : handleCheckAll;

  return (
    <Checkbox indeterminate={indeterminate} checked={checked} onChange={onClick}>
      {`Selecione todos os afiliados (${affiliates?.length})`}
    </Checkbox>
  );
};
